<template>
    <VBtn v-if="!hasToggle" :icon="icon" color="medium-emphasis" path="theme" @click="onClick" icon size="small">
        <VIcon size="x-large" :icon="icon" />
    </VBtn>
</template>

<script setup>
import { useTheme } from 'vuetify'
const theme = useTheme();
const { setAppTheme } = useACookie();

const icon = computed(() => theme.global.name.value === 'dark'
    ? '$mdiWeatherNight'
    : '$mdiWeatherSunny'
)
const hasToggle = computed(() => !['dark', 'light'].includes(theme.name.value))

function onClick() {
    setAppTheme(theme.global.name.value === 'dark' ? 'light' : 'dark');
}
</script>